<template>
  <!--监控画面-->
  <div>
    <!--    <iframe  v-bind:src="/byzt/index_edit.html?stageId=" style="border:0px;width:100%;height:800px"></iframe>-->
    <iframe class="editIframeZT" v-bind:src="'/static/byzt/client_view.html?stageId='+stageId+'&token='+token"></iframe>
  </div>

</template>

<script setup>
// import { getToken } from '@/utils/auth'
import {useRouter} from "vue-router/dist/vue-router";
import {onBeforeMount, onMounted, ref} from "vue";
import {getWsUrlApi} from "@/api/modules/hmgl";
import {ElMessage} from "element-plus";

let router = useRouter()
// name: "hmbj",
// props: {
//   stageId: {
//     type: String
//   }
// }
let token = ref('')
let stageId = ref('')

onMounted(() => {
  // token.value=getToken();
  stageId.value = router.currentRoute.value.params.stageId

})
onBeforeMount(() => {
  getWsUrlApi().then(res => {
    if (res.data.code === 0) {
      window.localStorage.setItem('wsUrl', res.data.result)
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })
})

</script>

<style lang="scss" scoped>
.editIframeZT {
  /* 50= navbar  50  */
  min-height: calc(100vh - 88px);
  width: 100%;
  border: 0px;
}
</style>
